webpackJsonp([5],{

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      return !fn(el)
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint strict: "off" */
	/* global jsApi */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(5), __webpack_require__(17)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, pubsub, $script) {
		// We can't use strict here, because of errors in Gismo-map it won't work in IE10.
		//'use strict';
	
		/**
		 * Map
		 * A plugin that integrates with the Gizmo map API.
		 * @exports map
		 */
		var map = {
	
			/** Placeholder for base DOM element. */
			el: null,
	
			/** Boolean indicating if the map is visible. */
			mapIsVisible: true,
	
			/** Placeholder for the datalayer. */
			dataLayer: null,
	
			/** Integer value for zoom in map */
			zoom: null,
	
			/** Placeholder for the unitId. */
			unitId: null,
	
			/** Placeholder for the items array. */
			items: [],
	
			/** Placeholder for the loaded features array. */
			loadedFeatures: [],
	
	
			/**
			 * The initialization function for this module.
			 * @param {Object} el - A DOM node.
			 * @public
			 */
			init: function (el) {
				this.el = el;
				this.dataLayer = el.getAttribute('data-datalayer');
				this.unitId = el.getAttribute('data-id');
				this.zoom = el.getAttribute('data-map-zoom') ? Number(el.getAttribute('data-map-zoom')) : 1;
				this.items = el.getAttribute('data-items') || [];
				this.fixedZoom = el.getAttribute('data-fixed-zoom') === 'true';
				this.mapIsVisible = (window.innerWidth || document.documentElement.clientWidth) >= 768;
	
				if (this.dataLayer && this.unitId || this.items.length > 0) {
					this._initEvents();
					this._initSubscriptions();
					this._initMapToggleLink();
	
					if (this.mapIsVisible) {
						this._loadGismoScript();
					}
				}
			},
	
	
			/**
			 * Displays one or more units on the map based on their datalayer and ogc_fid.
			 * @param {String} dataLayer - Name of the datalayer.
			 * @param {(String|String[])} id - An id as a string or an array of id-strings.
			 * @private
			 */
			_displayUnitsById: function (dataLayer, id) {
				var that = this;
	
				jsApi.search.doSearch(dataLayer, 'ogc_fid', id, {
					success: function (res) {
						for (var i = 0; i < res.length; i++) {
							that.loadedFeatures[res[i].attributes.ogc_fid] = res[i];
						}
	
						jsApi.map.showFeature(res, {});
	
						if (that.fixedZoom) {
							jsApi.map.moveTo(6566858.92, 153535.264, 1);
						} else {
							jsApi.map.zoomToShowAllFeatures();
							jsApi.map.zoomTo(that.zoom);
						}
					},
					failure: function () {}
				});
			},
	
	
			/**
			 * Removes one or more units from the map.
			 * @param {Object[]} items - An array containing items as objects with id and dataLayer properties.
			 * @private
			 */
			_removeUnits: function (removedItems) {
				for (var i = 0; i < removedItems.length; i++) {
					jsApi.map.removeFeature(this.loadedFeatures[removedItems[i].ogc_fid]);
				}
			},
	
	
			/**
			 * Displays items on the map based on an array of items.
			 * @param {Object[]} items - An array containing items as objects with id and dataLayer properties.
			 * @private
			 */
			_displayUnitsByItems: function (items) {
				var itemsGrouped = {};
	
				for (var i = 0; i < items.length; i++) {
					if (itemsGrouped[items[i].dataLayer] === undefined) {
						itemsGrouped[items[i].dataLayer] = [];
					}
					itemsGrouped[items[i].dataLayer].push(items[i].ogc_fid);
				}
	
				for (var key in itemsGrouped) {
					if (itemsGrouped.hasOwnProperty(key)) {
						this._displayUnitsById(key, itemsGrouped[key]);
					}
				}
			},
	
	
			/**
			 * Updates the map with new items, and/or removes old items.
			 * @param {Object[]} items - An array containing items as objects with id and dataLayer properties.
			 * @private
			 */
			_updateMapByItems: function (items) {
				var oldArray = this.items,
					newArray = items,
					removedItems = this._diffArrays(oldArray, newArray, 'ogc_fid'),
					newItems = this._diffArrays(newArray, oldArray, 'ogc_fid');
	
				if (this.mapIsVisible) {
					this._removeUnits(removedItems);
					this._displayUnitsByItems(newItems);
				}
	
				this.items = newArray;
			},
	
	
			/**
			 * Loads the Gismo-scripts asynchronously.
			 * @private
			 */
			_loadGismoScript: function () {
				var that = this,
					gismoUrl = mainConfig.gismoUrl;
	
				$script.get(gismoUrl, function () {
					that._removejscssfile('core.css', 'css');
				});
			},
	
	
			/**
			 * Helper function that removes some unwanted stylessheets that Gismo loads.
			 * @private
			 */
			_removejscssfile: function (filename, filetype) {
				var targetelement = (filetype === 'js') ? 'script' : (filetype === 'css') ? 'link' : 'none',
					targetattr = (filetype === 'js') ? 'src' : (filetype === 'css') ? 'href' : 'none',
					allsuspects = document.getElementsByTagName(targetelement);
	
				for (var i = allsuspects.length; i >= 0; i--) {
					if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) !== null && allsuspects[i].getAttribute(targetattr).indexOf(filename) !== -1) {
						allsuspects[i].parentNode.removeChild(allsuspects[i]);
					}
				}
			},
	
	
			/**
			 * Set up the "toggle-map" link click event (toggle-links are used on mobile devices to display the map).
			 * @private
			 */
			_initMapToggleLink: function () {
				var that = this,
					els = document.querySelectorAll('[data-type="toggle-map"]'),
					clickHandler;
	
				if (els.length > 0) {
					clickHandler = function (event) {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
	
						var el = event.target,
							target = document.getElementById(el.getAttribute('aria-controls'));
	
						that._toggleMobileMap(target, this);
					};
	
					for (var i = 0; i < els.length; i++) {
						var el = els[i];
	
						utils.addEventListener(el, 'click', clickHandler);
					}
				}
			},
	
	
			/**
			 * Toggles the visibility of the map on mobile devices.
			 * @private
			 */
			_toggleMobileMap: function (target, caller) {
				if (utils.hasClass(target, 'is-active')) {
					caller.setAttribute('aria-expanded', 'false');
					this.el.setAttribute('aria-hidden', 'true');
					utils.removeClass(target, 'is-active');
					utils.removeClass(document.body, 'is-fixed');
					window.scrollTo(0, this.scrollY);
				} else {
					this.scrollY = window.pageYOffset || document.documentElement.scrollTop;
					caller.setAttribute('aria-expanded', 'true');
					target.setAttribute('aria-hidden', 'false');
					utils.addClass(target, 'is-active');
					utils.addClass(document.body, 'is-fixed');
					this.mapIsVisible = true;
	
					if (!utils.hasClass(this.el, 'map-is-initiated')) {
						this._loadGismoScript();
					}
				}
			},
	
	
			/**
			 * Initiates events.
			 * @private
			 */
			_initEvents: function () {
				var that = this;
	
				window.onGismoApiInitialized = function () {
					utils.addClass(that.el, 'map-is-initiated');
					jsApi.settings.setPermaLinkActive(false);
					jsApi.map.moveTo(6566858.92, 153535.264, 1);
	
					if (that.dataLayer && that.unitId) {
						that._displayUnitsById(that.dataLayer, that.unitId);
					}
					else if (that.items) {
						try {
							that.items = JSON.parse(that.items);
							that._displayUnitsByItems(that.items);
						} catch (e) {}
					}
				};
			},
	
	
			/**
			 * Initiates subscriptions.
			 * @private
			 */
			_initSubscriptions: function () {
				var that = this;
	
				pubsub.subscribe('/map/update', function (data) {
					if (typeof(data) === 'object') {
						try {
							that._updateMapByItems(data);
						} catch (e) {}
					} else {
						try {
							that._updateMapByItems(JSON.parse(data));
						} catch (e) {}
					}
				});
			},
	
	
			/**
			 * Campare two arrays and return the items that differ.
			 * @private
			 */
			_diffArrays: function (arr1, arr2, idParam) {
				// Make hashtable of ids in B
				var arr2Ids = {};
				arr2.forEach(function (obj) {
					arr2Ids[obj[idParam]] = obj;
				});
	
				// Return all elements in A, unless in B
				return arr1.filter(function (obj) {
					return !(obj[idParam] in arr2Ids);
				});
			}
		};
	
		return map;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ })

});


// WEBPACK FOOTER //
// partial.5.js